<div class="content">
    <form [formGroup]="formGodzilla" >
        <div *ngIf="currentPage === 1">
        <div class="row spaceForm">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2 mt-3 center">
                <br/> <br/> <br/>
                <span class="titleForm">Información de suscripción</span>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-4 form-stilos">
                <div class="form-group">
                  
                    <input type="text" maxlength="40" class="form-control inputForms" formControlName="name" placeholder="Nombres *">
                    <div class="containerError" *ngIf="(submitAttempted || formGodzilla.get('name')?.touched) && formGodzilla.get('name')?.hasError('required')">
                        <mat-icon class="alerta-error" matSuffix>error_outline</mat-icon>
                        <span class="mda-form-msg"><strong>Escribe tu nombre</strong></span>
                    </div>
  
  
                </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-4">
                <div class="form-group">
                  
                    <input type="text" maxlength="80" class="form-control inputForms" formControlName="lastName" placeholder="Apellidos *">
                    <div class="containerError" *ngIf="(submitAttempted || formGodzilla.get('lastName')?.touched) && formGodzilla.get('lastName')?.hasError('required')">
                        <mat-icon class="alerta-error" matSuffix>error_outline</mat-icon>
                        <span class="mda-form-msg"><strong>Escribe tu Apellido</strong></span>
                    </div>

                </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-4">
                <div class="form-group">
                   
                    <input type="number" (input)="limitLong($event)" min="1000000000" max="999999999999999" class="form-control inputForms" formControlName="phoneNumber" placeholder="Celular *">
                   
                    <div class="containerError" *ngIf="(submitAttempted || formGodzilla.get('phoneNumber')?.touched) && formGodzilla.get('phoneNumber')?.invalid">
                        <mat-icon class="alerta-error" matSuffix>error_outline</mat-icon>
                        <span class="mda-form-msg">Escribe un teléfono entre 10 y 15 dígitos</span>
                      </div>
                      
                </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-4">
                <div class="form-group">
                    <input type="email" maxlength="40" class="form-control inputForms" formControlName="email" placeholder="Correo electronico *">
                    <div class="containerError" *ngIf="(submitAttempted || formGodzilla.get('email')?.touched) && formGodzilla.get('email')?.invalid">
                        <mat-icon class="alerta-error" matSuffix>error_outline</mat-icon>
                        <span class="mda-form-msg">Escribe un correo electrónico válido</span>
                      </div>

                </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-4" style="display: none;">
                <div class="form-group">
                    <input type="text" class="form-control inputForms" formControlName="utm_source">
                    <input type="text" class="form-control inputForms" formControlName="utm_medium">
                    <input type="text" class="form-control inputForms" formControlName="utm_campaign">
                    <input type="text" class="form-control inputForms" formControlName="utm_content">
                </div>
            </div>

        
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 caja-check">
                <div class="form-check policiesDiv">
                    <input class="form-check-input checkPolicies" type="checkbox" formControlName="politics" id="politics" checked>
                    <p class="privacyPolicies" for="politics">
                        He leído y acepto la <a class="policies" [href]="urlPolitics" target="_blank">política de tratamiento</a> de datos personales
                    </p>
                  </div>
                  <div class="form-check policiesdiverror">
                    <div class="containerError term" *ngIf="(submitAttempted || formGodzilla.get('politics')?.touched) && formGodzilla.get('politics')?.hasError('required')">
                        <mat-icon class="alerta-error" matSuffix>error_outline</mat-icon>
                        <span class="mda-form-msg"><strong>Debes aceptar los terminos</strong></span>
                    </div>
                 </div>
       
            </div>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2 mt-3 center">

            <!-- Botón para suscribirse -->
<button type="button" (click)="checkFormBeforeProceed()" mat-raised-button class="btn-azul" color="primary">SUSCRIBIRME</button>



       </div>
       
    </div>
        <div *ngIf="currentPage === 2">

        <div class="row spaceForm gris">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-5 mb-1">
                <span class="titleFor">Selección de suscripción</span>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12  mb-5">
                <span class="subtitleForm">Puedes suscribirte a un grupo de temas con el check o a una en específico seleccionándola</span>
                <hr/>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12  mb-5" *ngFor="let superGroup of listThematic">
                <app-card [superGroup]="superGroup" (returnData)="updateThematics(superGroup,$event)"></app-card>
            </div>
        </div>
        
       
        <div class="row spaceForm">
            <div class="bloque-abajo buttonFinishDiv">
                <button type="button" class="btn-atras" (click)="goToPage(1)"> < </button>
                 <button type="button" *ngIf="!loading"  (click)="sendFormGodzilla()" [disabled]="formIsValid()" mat-raised-button class="buttonFinish">Finalizar suscripción</button>
            <div class="spinner">        
                <mat-progress-spinner class="loaderForm" *ngIf="loading"  color="primary" mode="indeterminate" >
                </mat-progress-spinner>
            </div>    
            </div>
        </div>
    </div>
    </form>
</div>